import { useReducer } from 'react';
import { AnalyticsContext } from './analyticsContext';
import { analyticsReducer, initialAnalyticsState } from './analyticsReducer';
import type { ReactNode } from 'react';

interface AnalyticsProviderProps {
  children: ReactNode;
}

export const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
  const [analyticsState, dispatch] = useReducer(analyticsReducer, initialAnalyticsState);

  return (
    <AnalyticsContext value={{ analyticsState, dispatch }}>
      {children}
    </AnalyticsContext>
  );
};